module.exports = __webpack_public_path__ + "img/variant_details.11458f88.png";